import React, { useState } from 'react';
import { PERMISOS } from '../utils/permisos';
import { guardarPermisos } from '../services/equipoService';
import { useToast } from '../context/ToastContext';

// Interruptores de permisos de una persona del equipo (Mi equipo → Permisos).
export default function PermisosMiembro({ miembro, onGuardado, onCerrar }) {
  const { mostrarToast } = useToast();
  const [valores, setValores] = useState({ ...(miembro.permisos || {}) });
  const [guardando, setGuardando] = useState(false);
  const cambiar = (clave) => setValores((v) => ({ ...v, [clave]: !v[clave] }));
  const activos = Object.values(valores).filter(Boolean).length;

  const guardar = async () => {
    setGuardando(true);
    try {
      const nuevos = await guardarPermisos(miembro.user_id, valores);
      mostrarToast('Permisos guardados ✅ Se aplican en cuanto esa persona vuelva a abrir Kontrol.', 'exito', 6000);
      onGuardado(nuevos);
    } catch (e) { mostrarToast(e.message, 'error'); }
    setGuardando(false);
  };

  return (
    <div style={{ width: '100%', background: '#FAF8FF', border: '1px solid #E4DEF2', borderRadius: '12px', padding: '14px', marginTop: '6px' }}>
      <p style={{ margin: '0 0 10px', fontSize: '13px', color: '#6B7280' }}>
        Siempre puede vender, ver el inventario, clientes, pedidos, servicios, cotizaciones, agenda y órdenes. Activa lo que necesites que haga además:
      </p>
      {PERMISOS.map((g) => (
        <div key={g.grupo} style={{ marginBottom: '10px' }}>
          <div style={{ fontSize: '11px', fontWeight: 700, color: '#6D28D9', textTransform: 'uppercase', letterSpacing: '.05em', margin: '6px 0' }}>{g.grupo}</div>
          {g.items.map((p) => {
            const on = !!valores[p.clave];
            const id = `perm-${miembro.user_id}-${p.clave}`;
            return (
              <label key={p.clave} htmlFor={id} style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '8px 0', borderTop: '1px solid #EFEAF8', cursor: 'pointer' }}>
                <span style={{ flex: 1, minWidth: 0 }}>
                  <span style={{ display: 'block', fontSize: '14px', fontWeight: 600, color: '#1C1830' }}>{p.nombre}</span>
                  {p.ayuda && <span style={{ display: 'block', fontSize: '12px', color: '#6B7280' }}>{p.ayuda}</span>}
                </span>
                <input id={id} type="checkbox" role="switch" aria-checked={on} checked={on} onChange={() => cambiar(p.clave)} disabled={guardando}
                  style={{ position: 'absolute', opacity: 0, width: 1, height: 1 }} />
                <span aria-hidden="true" style={{ width: '42px', height: '24px', borderRadius: '999px', background: on ? 'var(--color-primario,#6D28D9)' : '#D1D5DB', position: 'relative', flexShrink: 0, transition: 'background .15s' }}>
                  <span style={{ position: 'absolute', top: '3px', left: on ? '21px' : '3px', width: '18px', height: '18px', borderRadius: '50%', background: '#fff', transition: 'left .15s', boxShadow: '0 1px 2px rgba(0,0,0,.2)' }} />
                </span>
              </label>
            );
          })}
        </div>
      ))}
      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center', marginTop: '6px' }}>
        <button onClick={guardar} disabled={guardando}
          style={{ padding: '10px 16px', border: 'none', borderRadius: '10px', background: 'var(--color-primario,#6D28D9)', color: '#fff', fontWeight: 700, fontFamily: 'inherit', cursor: guardando ? 'wait' : 'pointer' }}>
          {guardando ? 'Guardando…' : 'Guardar permisos'}
        </button>
        <button onClick={onCerrar} disabled={guardando} className="k-btn-soft">Cancelar</button>
        <span style={{ fontSize: '12px', color: '#6B7280' }}>{activos} permiso(s) extra activado(s)</span>
      </div>
    </div>
  );
}
